import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b406fe50"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-base text-center text-gris80 font-bold mb-2" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = { class: "text-primary" }
const _hoisted_4 = {
  class: "text-gris120 text-sm mb-3",
  style: {"display":"inline-block"}
}
const _hoisted_5 = { class: "text-justify" }
const _hoisted_6 = { class: "font-bold" }
const _hoisted_7 = { class: "mb-2" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "text-gris120 text-xs"
}, "Ingrese el correo donde se enviará el soporte del acuerdo", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "w-full h-12 px-4 py-2 mt-2 text-base text-white rounded-lg bg-success border md:h-9 md:text-xs"
}, " Confirmar ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_NewModal = _resolveComponent("NewModal")!

  return (_ctx.isVisible)
    ? (_openBlock(), _createBlock(_component_NewModal, {
        key: 0,
        "custom-class": 'p-4 lg:p-6 max-w-2xl w-80 lg:w-88 bg-white rounded-lg',
        onCloseModal: _ctx.close
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Form, {
            onSubmit: _ctx.confirm,
            "validation-schema": _ctx.schemaForm
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createElementVNode("p", _hoisted_1, [
                  _createTextVNode(" Estamos a punto de hacer el "),
                  _hoisted_2,
                  _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.setHomologateProductsTitle(String(_ctx.currentNegotiation?.product_name))), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("p", _hoisted_5, [
                  _createTextVNode(" Su fecha límite para el pago mínimo de "),
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$filters.currency(_ctx.currentNegotiation?.initial_fee_value)), 1),
                  _createTextVNode(" es: ")
                ]),
                _createVNode(_component_Field, {
                  name: "deadlineDate",
                  modelValue: _ctx.deadlineDate,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.deadlineDate) = $event))
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_date_picker, _mergeProps(field, {
                      valueType: "format",
                      format: "DD/MM/YYYY",
                      placeholder: "DD/MM/YYYY",
                      "disabled-date": _ctx.notBeforeToday,
                      "validate-on-input": true,
                      class: "custom-datepicker"
                    }), null, 16, ["disabled-date"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "deadlineDate",
                  as: "div",
                  class: "mt-1 text-xs text-primary"
                })
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_Field, {
                  name: "email",
                  modelValue: _ctx.email,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email) = $event))
                }, {
                  default: _withCtx(({ field }) => [
                    _hoisted_8,
                    _createElementVNode("input", _mergeProps(field, {
                      type: "email",
                      name: "email",
                      class: "border w-full rounded h-8 py-1.5 px-2.5 text-gris120 font-sm"
                    }), null, 16)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "email",
                  as: "div",
                  class: "mt-1 text-xs text-primary"
                })
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  class: "w-full h-12 px-4 py-2 text-base text-white rounded-lg bg-secondary border md:h-9 md:text-xs md:mr-1",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.moreTime && _ctx.moreTime(...args)))
                }, " Necesito más tiempo "),
                _hoisted_9
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ]),
        _: 1
      }, 8, ["onCloseModal"]))
    : _createCommentVNode("", true)
}